import type { RouteRecordRaw } from 'vue-router'
import ImpulseLibraryPage from '../../modules/lumia/pages/ImpulseLibraryPage.vue'
import LessonImpulsePage from '../../modules/lumia/pages/LessonImpulsePage.vue'
import LessonPage from '../../modules/lumia/pages/LessonPage.vue'
import LessonTeacherAssessmentPage from '../../modules/lumia/pages/LessonTeacherAssessmentPage.vue'
import TeamMemberPage from '../../modules/lumia/pages/TeamMemberPage.vue'
import TeamPage from '../../modules/lumia/pages/TeamPage.vue'
import TeamPortalDisplayPage from '../../modules/portal/pages/TeamPortalDisplayPage.vue'
import TeamPortalPrintPage from '../../modules/portal/pages/TeamPortalPrintPage.vue'

export const lumiaRoutes: RouteRecordRaw[] = [
  {
    path: '/impulse-library',
    name: 'impulse-library',
    component: ImpulseLibraryPage,
  },
  {
    path: '/lessons/:lessonId',
    name: 'lessons-detail',
    component: LessonPage,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/lessons/:lessonId/teacher-assessment',
    name: 'lesson-teacher-assessment',
    component: LessonTeacherAssessmentPage,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/teams/:teamId',
    name: 'team',
    component: TeamPage,
  },
  {
    path: '/teams/:teamId/members/:memberId',
    name: 'team-member',
    component: TeamMemberPage,
  },
  {
    path: '/teams/:teamId/portal/print',
    name: 'team-portal-print',
    component: TeamPortalPrintPage,
    meta: { layout: 'print' },
  },
  {
    path: '/teams/:teamId/portal/display',
    name: 'team-portal-display',
    component: TeamPortalDisplayPage,
    meta: { layout: 'full-screen' },
  },
  {
    path: '/impulse-library/:id',
    name: 'impulse-library-detail',
    component: LessonImpulsePage,
    meta: { layout: 'full-screen' },
  },
]
